export default "__VITE_ASSET__365ef3ef__"